import styled from "@emotion/styled";

export const ThemeBox = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 12px;
  padding: 12px;
  border: 2px solid #ffee00;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  font-weight: bold;
`;

export const ThemeTitle = styled.div`
  white-space: pre-wrap;
  text-align: center;
`;
